import { createChunkReloadGuard } from '~/utils/chunkReloadGuard';

// A chunk that fails while the app is booting surfaces as `vite:preloadError` and leaves
// a blank page; nothing else recovers it. Once the app has mounted, Nuxt's own chunk
// error handling covers router navigations, so later events are ignored here.
export default defineNuxtPlugin({
   name: 'preload-error-reload',
   enforce: 'pre',
   setup(nuxtApp) {
      let mounted = false;
      nuxtApp.hook('app:mounted', () => {
         mounted = true;
      });
      window.addEventListener(
         'vite:preloadError',
         createChunkReloadGuard({
            getStorage: () => window.sessionStorage,
            fetchFn: (url, init) => fetch(url, init),
            reload: () => window.location.reload(),
            getHref: () => window.location.href,
            isActive: () => !mounted,
         }),
      );
   },
});
